import { motion } from 'motion/react';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { nanoid } from 'shared/utils/nanoid';
import type { TKey } from '~/lib/i18n-locales';
import { Button } from '~/modules/ui/button';

export type SheetTab = { id: string; label: TKey; element: React.ReactNode };

interface Props {
  tabs: SheetTab[];
  id?: string;
}

export function SheetTabs({ tabs }: Props) {
  const layoutId = nanoid();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(tabs[0]);

  const renderPage = () => currentPage.element;

  return (
    <div className="mb-20">
      {tabs.length > 1 && (
        <nav className="flex justify-center gap-2 pb-4">
          {tabs.map((tab) => (
            <div key={tab.id} className="relative">
              <Button
                variant="none"
                data-current={currentPage.id === tab.id}
                className="peer group opacity-80 hover:opacity-100 data-[current=true]:opacity-100"
                onClick={() => setCurrentPage(tab)}
              >
                <span className="block group-active:translate-y-[.05rem]">{t(tab.label)}</span>
                {currentPage.id === tab.id && (
                  <motion.span
                    initial={false}
                    layoutId={layoutId}
                    transition={{ type: 'spring', duration: 0.4, bounce: 0, delay: 0.1 }}
                    className="absolute bottom-0 left-2 h-1 w-[calc(100%-1rem)] rounded-sm bg-primary"
                  />
                )}
              </Button>
            </div>
          ))}
        </nav>
      )}
      <div className="container">
        <Suspense>{renderPage()}</Suspense>
      </div>
    </div>
  );
}
